import { useCallback } from 'react';
import { T } from '../helpers/i18n';
export var useApplyCommission = function (store) {
    return useCallback(function (collaborator) {
        if (confirm(T('applyCommission'))) {
            store.collaboratorStore.applyCommission(collaborator.id)
                .then(function () {
                store.UI.newWarning('appliedCorrectly');
            })
                .catch(function () {
                store.UI.newError(T('appliedError'));
            });
        }
    }, [store]);
};



//////////////////
// WEBPACK FOOTER
// ./src/hooks/useApplyCommission.ts
// module id = 1567
// module chunks = 0